import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {IncidentsActions, IncidentsSelectors} from '../../../store/incidents/incidents.index';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../../store/store.index';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-edit-planned-delivery-overlay',
  templateUrl: 'edit.planned.delivery.component.html'
})
export class EditPlannedDeliveryComponent implements OnInit {

  editFormGroup: FormGroup;
  incidents$: Observable<ProleisObject[]>;

  constructor(private bs: MatBottomSheetRef, @Inject(MAT_BOTTOM_SHEET_DATA) private data: ProleisObject,
              private store: Store<ProleisSuppliersState>, @Inject(APP_GUIDS) private guids: AppGuids) {

  }

  ngOnInit() {
    const validatePlannedCount: ValidatorFn = (fg: FormGroup) => {
      const plannedCount = fg.get('plannedCount').value;
      const incidentCount = fg.get('deliveryIncident').value?.PARTS_AFFECTED;
      if (plannedCount > incidentCount) {
        return {
          mismatchedCount: true
        };
      }
      return null;
    };

    this.editFormGroup = new FormGroup({
      plannedCount: new FormControl(this.data.delivery.PLANNED_COUNT, [Validators.min(1), Validators.required]),
      plannedDate: new FormControl(this.data.delivery.PLANNED_DATE, [Validators.nullValidator, Validators.required]),
      deliveryComment: new FormControl(this.data.delivery.DELIVERYNOTE_COMMENT),
      deliveryIncident: new FormControl(this.data.incident)
    }, {
      validators: validatePlannedCount,
      updateOn: 'blur'
    });

    this.store.dispatch(IncidentsActions.LOAD_INCIDENTS({
      orderId: this.data.pboId,
      posId: this.data.posId,
      aliasFields: ''
    }));

    this.incidents$ = this.store.select(IncidentsSelectors.selectIncidents);
  }

  save() {
    this.bs.dismiss({
      plannedDate: new Date(this.editFormGroup.get('plannedDate').value),
      plannedCount: this.editFormGroup.get('plannedCount').value,
      deliveryComment: this.editFormGroup.get('deliveryComment').value,
      incidentId: this.editFormGroup.get('deliveryIncident').value
    });
  }

  dismiss() {
    this.bs.dismiss();
  }

  isQsDelivery() {
    return this.guids.GUID_TYPE_RECEIVE_QS_PARTS === this.data.delivery.PBOSUBTYPEGUID;
  }

  compareIncidents(o1: ProleisObject, o2: ProleisObject) {
    return o1.OBJECT_ID === o2.OBJECT_ID;
  }

}
